document.addEventListener('click', function(event) {
  const navLink = event.target.closest('.mobile-nav-content a');
  if (navLink) navLink.closest('details').removeAttribute('open');
  const imageButton = event.target.closest('[data-product-image]');
  if (imageButton) {
    const target = document.getElementById(imageButton.dataset.imageTarget);
    if (target) { target.src = imageButton.dataset.productImage; target.removeAttribute('srcset'); }
  }
  const viewButton = event.target.closest('[data-preview-view]');
  if (viewButton) {
    const soon = viewButton.dataset.previewView === 'soon';
    document.querySelector('[data-home-view]').hidden = soon;
    document.querySelector('[data-soon-view]').hidden = !soon;
    document.querySelectorAll('[data-preview-view]').forEach(b => b.setAttribute('aria-selected', String(b === viewButton)));
    window.scrollTo({ top: 0, behavior: 'instant' });
    history.replaceState(null, '', soon ? '#coming-soon' : location.pathname);
  }
});
document.addEventListener('change', function(event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const price = document.getElementById(select.dataset.priceTarget);
  if (price) price.textContent = option.dataset.price;
  const button = form.querySelector('[data-add-to-cart]');
  if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to bowl'; }
  if (option.dataset.image) { const image = document.getElementById(select.dataset.imageTarget); if (image) {image.src = option.dataset.image; image.removeAttribute('srcset');} }
});
document.addEventListener('submit', function(event) {
  if (event.target.matches('[data-preview-signup]')) {
    event.preventDefault();
    const message = event.target.querySelector('[role="status"]');
    if (message) message.textContent = 'This is a design preview. Your email has not been submitted.';
  }
});
if (location.hash === '#coming-soon') {
  const button = document.querySelector('[data-preview-view="soon"]');
  if (button) button.click();
}
